import store from '@/store'
import {orderBy} from 'lodash'
import {getSorter} from '@/lib/sortOptions'

const List = {}
let activeTags = []

List.getActiveTags = () => {
  return activeTags
}

List.search = async (list, query = '', options = [], apiSearch = null) => {
  activeTags = [] // reset

  if (!query) {
    return list
  }

  let search = []
  let users = []
  query.split(';').forEach(part => {
    if (options.includes('tags')) {
      const tagx = /^[\s]?tag:([^;]*)/gi.exec(part)
      if (tagx) {
        activeTags = activeTags.concat(tagx[1].split(',').map(t => t.trim()))
        return
      }
    }
    if (options.includes('author')) {
      const userx = /^[\s]?user:([^;]*)/gi.exec(part)
      if (userx) {
        users = users.concat(userx[1].split(','))
        return
      }
    }

    search = search.concat(part.split(' '))
  })
  let filteredArray = list

  if (search.length > 0) {
    let ids = []
    if (options.includes('api') && apiSearch) {
      ids = await apiSearch(search.join(' '))
    }

    filteredArray = filteredArray.filter(obj =>
      filterBySearch(obj, search.map(lower), options, ids)
    )
  }

  if (activeTags.length > 0) {
    filteredArray = filteredArray.filter(obj => filterByTags(obj, activeTags))
  }

  if (users.length > 0) {
    filteredArray = filteredArray.filter(obj =>
      filterByAuthor(obj, users.map(lower))
    )
  }
  return filteredArray
}
List.sort = (list, criteria) => {
  const sorter = getSorter(criteria)
  return orderBy(list, sorter.field, sorter.order)
}

List.tagMatch = (search, t, opts) => {
  if (search[0] === '"') {
    // exact match
    return `"${t.label}"` === search
  } else {
    let prefix = ''
    if (opts && opts.strict) {
      prefix = '^'
    }
    const s = lower(search)
    const searchx = new RegExp(`${prefix}${s}`)
    return t.label.toLowerCase().match(searchx)
  }
}

/*
 * Helpers
 */
function filterByAuthor(object, authorFilter) {
  for (let user of authorFilter) {
    const author = store.getters.getUserByID(object.author)
    if (author && author.username.toLowerCase().indexOf(user) > -1) {
      return true
    }
  }
  return false
}
function filterBySearch(object, query, options, ids) {
  let searchable = ''
  for (let option of options) {
    switch (option) {
      case 'tags': // search in tags
        for (let tag of object.tags) {
          searchable += ' ' + tag.slug
        }
        break
      case 'author':
        {
          const author = store.getters.getUserByID(object.author)
          if (author) {
            searchable += ' ' + author.username // search in author
          }
        }
        break
      default:
        // search in title, excerpt, body, etc
        searchable += ' ' + object[option]
    }
  }
  searchable = searchable.toLowerCase()
  for (let part of query) {
    if (searchable.indexOf(part) === -1) {
      return ids.includes(object._id)
    }
  }
  return true
}
function filterByTags(object, tagFilters) {
  for (let tag of tagFilters) {
    const result = object.tags.find(t => List.tagMatch(tag, t))
    if (!result) {
      return false
    }
  }
  return true
}
function lower(str) {
  return str.toLowerCase().trim()
}

export default List
